const CACHE_KEY = 'portal_dashboard_refresh_v1'

/** Intervalo fijo entre snapshots del portal cliente (10 min). */
export const PORTAL_DASHBOARD_REFRESH_MS = 10 * 60 * 1000

function tokenKey(token) {
  return token && token.length >= 16 ? token.slice(-16) : ''
}

function readCache() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

function writeCache(state) {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(state))
  } catch (_) {}
}

export function clearPortalDashboardCache() {
  try {
    sessionStorage.removeItem(CACHE_KEY)
  } catch (_) {}
}

/**
 * @returns {{ shouldFetch: boolean, nextFetchAt: string|null, cache: object|null }}
 */
export function getPortalDashboardSchedule(token) {
  const cache = readCache()
  const key = tokenKey(token)
  if (!cache || cache.tokenKey !== key) {
    return { shouldFetch: true, nextFetchAt: null, cache: null }
  }
  const nextFetchAt = cache.nextFetchAt || null
  if (!nextFetchAt) {
    return { shouldFetch: true, nextFetchAt: null, cache }
  }
  const due = Date.now() >= new Date(nextFetchAt).getTime()
  return { shouldFetch: due, nextFetchAt, cache }
}

export function getCachedPortalDashboard(installationId, token) {
  const { cache, shouldFetch } = getPortalDashboardSchedule(token)
  if (!cache || shouldFetch) return null
  const slot = cache.byInstallation?.[String(installationId || 'default')]
  return slot?.data || null
}

/**
 * Fetch when the global refresh window elapsed OR this installation has no cached snapshot yet.
 * (Org/install switch must not show empty KPIs until the next 10 min tick.)
 */
export function shouldFetchPortalDashboard(installationId, token) {
  const { shouldFetch, cache } = getPortalDashboardSchedule(token)
  if (shouldFetch) return true
  if (!cache) return true
  const slot = cache.byInstallation?.[String(installationId || 'default')]
  return !slot?.data
}

export function storePortalDashboardSnapshot(installationId, token, data) {
  const key = tokenKey(token)
  const existing = readCache()
  const byInstallation =
    existing?.tokenKey === key && existing.byInstallation ? { ...existing.byInstallation } : {}
  byInstallation[String(installationId || 'default')] = {
    data,
    cachedAt: new Date().toISOString(),
  }
  writeCache({
    tokenKey: key,
    nextFetchAt: new Date(Date.now() + PORTAL_DASHBOARD_REFRESH_MS).toISOString(),
    byInstallation,
  })
}
